var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 22,
    viewBox: "0 0 39 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3303_246716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 12.5723C14.3107 12.5723 10.1041 16.7935 10.1041 22.0008H28.8958C28.8958 16.7935 24.6892 12.5723 19.5 12.5723Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.775 12.5711C33.3696 12.5711 35.4729 10.4605 35.4729 7.85686C35.4729 5.25324 33.3696 3.14258 30.775 3.14258C28.1804 3.14258 26.0771 5.25324 26.0771 7.85686C26.0771 10.4605 28.1804 12.5711 30.775 12.5711Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.775 13.4102C29.5164 13.4102 28.3321 13.7225 27.2888 14.2705C29.2482 16.2584 30.4618 18.9907 30.4618 22H38.2173C38.2643 21.6582 38.2917 21.3085 38.2917 20.953C38.2917 16.7868 34.9268 13.4102 30.775 13.4102Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22498 13.4102C4.0732 13.4102 0.708313 16.7868 0.708313 20.953C0.708313 21.3085 0.73376 21.6582 0.782697 22H8.53817C8.53817 18.9887 9.74984 16.2584 11.7112 14.2705C10.6699 13.7225 9.48363 13.4102 8.22498 13.4102Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 11C22.527 11 24.9809 8.53757 24.9809 5.5C24.9809 2.46243 22.527 0 19.5 0C16.473 0 14.0191 2.46243 14.0191 5.5C14.0191 8.53757 16.473 11 19.5 11Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.22496 12.5711C10.8195 12.5711 12.9229 10.4605 12.9229 7.85686C12.9229 5.25324 10.8195 3.14258 8.22496 3.14258C5.63037 3.14258 3.52704 5.25324 3.52704 7.85686C3.52704 10.4605 5.63037 12.5711 8.22496 12.5711Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3303_246716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.5833,
    height: 22,
    fill: "white",
    transform: "translate(0.708313)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.3778504372322e8fbbb636a4ee4585fa.svg";
export { ForwardRef as ReactComponent };